<template>
  <div class="view-change-card container py-9">
    <img height="20" src="../assets/images/logo.svg" />
    <h2 class="mb-5 mb-lg-8">Trocar cartão</h2>

    <form @submit.prevent="submit" class="row">
      <div class="col-lg-6">
        <form-group
          label="Número do cartão"
          placeholder="Ex: 1234 5678 1234 5678"
          v-model="form.number"
          :errors="errors.number"
          id="number"
          type="tel"
          mask="#### #### #### ####"
        />
        <form-group
          label="Titular do cartão"
          placeholder="Ex: Jhon Doe"
          v-model="form.holder_name"
          :errors="errors.holder_name"
          id="holder_name"
        />
        <div class="form-row">
          <div class="col-6">
            <div class="form-group mb-0 pt-3">
              <label>Data de validade</label>
            </div>
            <div class="form-row">
              <div class="col-6">
                <form-group
                  placeholder="MM"
                  v-model="form.exp_month"
                  :errors="errors.exp_month"
                  id="exp_month"
                  type="tel"
                  mask="##"
                  masked
                  class="pt-0"
                />
              </div>
              <div class="col-6">
                <form-group
                  placeholder="AA"
                  v-model="form.exp_year"
                  :errors="errors.exp_year"
                  id="exp_year"
                  type="tel"
                  mask="####"
                  masked
                  class="pt-0"
                />
              </div>
            </div>
          </div>
          <div class="col-6">
            <form-group
              label="Código de segurança"
              placeholder="CVV"
              v-model="form.cvv"
              :errors="errors.cvv"
              id="cvv"
              type="tel"
              mask="####"
            />
          </div>
        </div>

        <div class="text-right pt-lg-8 pt-6 mb-5">
          <button
            class="btn btn-success btn-fixed-size"
            type="submit"
            :disabled="loading"
          >
            <loading :show="loading">Salvar</loading>
          </button>
        </div>
      </div>

      <div class="col-lg-6 d-none d-lg-block pt-6 mt-5">
        <div class="preview-credit-card">
          <div class="d-flex">
            <div class="img chip" />
            <span class="flex-fill"></span>
            <span>{{ form.cvv ? form.cvv : "***" }}</span>
          </div>
          <div class="pt-6 pb-5">
            {{ cardNumber ? cardNumber : "**** **** **** ****" }}
          </div>
          <div class="d-flex">
            <span>{{ holderName ? holderName : "***** * *****" }}</span>
            <span class="flex-fill"></span>
            <span
              >{{ form.exp_month ? form.exp_month : "**" }}/{{
                form.exp_year ? form.exp_year : "**"
              }}</span
            >
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers.js";

export default {
  data() {
    return {
      loading: false,
      ...formFields(["number", "holder_name", "exp_year", "exp_month", "cvv"])
    };
  },
  computed: {
    cardNumber: function() {
      var result = "";
      for (var i in this.form.number) {
        result += this.form.number[i];

        if (i % 4 === 3) {
          result += " ";
        }
      }
      return result;
    },
    holderName: function() {
      return (this.form.holder_name || "").toUpperCase();
    }
  },
  methods: {
    submit() {
      this.loading = true;
      let params = {
        ...this.form,
        token: this.$route.params.token
      };
      this.$store
        .dispatch("subscriptions/changeCard", params)
        .then(() => {
          this.$message.success("Cartão trocado com sucesso");
        })
        .catch(error => {
          this.errors = error.response.data;
          if (this.errors.non_field_errors) {
            this.$message.error(this.errors.non_field_errors[0]);
          }
          if (this.errors.detail) {
            this.$message.error(this.errors.detail);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.view-change-card {
  .preview-credit-card {
    background: rgba(33, 38, 49, 0.05);
    border: 1px solid rgba(33, 38, 49, 0.1);
    border-radius: 16px;
    box-sizing: border-box;
    padding: 60px 24px 16px;
    letter-spacing: 0.16em;
    font-weight: bold;
    font-size: 17px;
    line-height: 23px;
    font-family: monospace;
    color: #979797;
    max-width: 400px;

    .chip {
      background-image: url("../assets/images/chip.svg");
      height: 38px;
      width: 56px;
    }
  }
}
</style>
